import {writable} from 'svelte/store';

let localGeosObject = {
    list: [],
    tree: [],

    selected_id: 0,
    last_selected_id: 0,
    marked_id: 0,
    edit_id: null,
    search_term: '',

    match_source: 0,
};

const {get, set, update, subscribe} = writable(localGeosObject)

const localGeos = {
    subscribe,
    update,
    set: o => {
        set(localGeosObject);
    },
}

export default localGeos;